import { Alert } from '@designsforhealth/dfh-react-components'
import React, { FC } from 'react'
import styled from 'styled-components'

import useSiteSettings from '../../../../hooks/useSiteSettings'
import { eftAndTaxTitle } from '../../../../lib/practitioner-settings/customerForms'
import { usePractitionerSettings } from '../../../../lib/practitioner-settings/hooks/usePractitionerSettings'
import Spinner from '../../../Spinner'
import EftAndTaxSection from './practitioner/EftAndTaxSection'

const Container = styled.div`
  @media (min-width: 768px) {
    max-width: 450px;
    h3 {
      max-width: 350px;
    }
  }
`

const EftAndTaxContainer: FC = () => {
  const [settings, { loading, error, called }] = usePractitionerSettings()
  const siteSettings = useSiteSettings()

  if (!called || loading) {
    return <Spinner loading />
  }

  if (error || !settings) {
    console.error('Error loading practitioner settings', error)
    return (
      <Alert type="error">
        We were unable to load your practitioner settings, please try again soon.
      </Alert>
    )
  }

  // determine title from whether form link is populated
  const titleText = eftAndTaxTitle(siteSettings)
  if (!titleText) {
    return null
  }

  return (
    <Container>
      <h3>{titleText}</h3>
      <hr />
      <EftAndTaxSection settings={settings} />
    </Container>
  )
}

export default EftAndTaxContainer
